<template>
  <div>
    <label class="block text-sm font-semibold text-argus-forest-300 mb-1">{{ label }}</label>
    <textarea
      v-if="rows"
      :value="modelValue"
      :rows="rows"
      :placeholder="placeholder"
      :class="inputClass"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <input
      v-else
      :value="modelValue"
      :type="type"
      :step="step"
      :max="max"
      :placeholder="placeholder"
      :class="inputClass"
      @input="onInput"
    />
    <p v-if="error" class="text-argus-red text-sm mt-1">{{ error }}</p>
  </div>
</template>
<script>
const BASE = 'w-full px-3 py-2 text-sm border rounded-lg focus:outline-none bg-white/10 text-argus-forest-100 placeholder-argus-forest-400'
const NORMAL = 'border-argus-forest-500/40 focus:border-argus-emerald-400'
const ERRORED = 'border-argus-red'

export default {
  props: {
    label: { type: String, required: true },
    modelValue: { default: '' },
    type: { type: String, default: 'text' },
    rows: { type: [String, Number], default: '' },
    step: { type: String, default: '' },
    max: { type: [String, Number], default: '' },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    mono: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    inputClass() {
      return [
        BASE,
        this.error ? ERRORED : NORMAL,
        this.mono ? 'font-mono' : '',
      ]
    },
  },
  methods: {
    onInput(ev) {
      const raw = ev.target.value
      if (this.type === 'number') {
        this.$emit('update:modelValue', this.step ? parseFloat(raw) : parseInt(raw, 10))
      } else {
        this.$emit('update:modelValue', raw)
      }
    },
  },
}
</script>